import Featured from 'components/Featured';
import Teaser from 'components/Teaser';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
// Import Components
import { Col } from 'react-bootstrap';
// Import styles
import styles from './style.scss';

/**
 * Overview component
 */
@inject('MediahubStore', 'ViewStore')
@observer
class Overview extends Component {

  render() {
    const { MediahubStore, ViewStore } = this.props;
    const lang                         = ViewStore.language;

    return (
      <div ref={(ref) => this._container = ref} className={styles.container + ' row'} >
        <Col xs={12} >
          {
            !!MediahubStore.featuredMediaContainer && (
              <Featured
                mc={MediahubStore.featuredMediaContainer} />
            )
          }
          {/* {
            _.map(MediahubStore.specialChannels, (c, index) =>
              <Teaser
                key={`channel_${index}`}
                channelTitle={c.title}
                items={c.teasers} />,
            )
          } */}
          {
            _.map(MediahubStore.channelsWithoutFeatured, (c, index) =>
              <Teaser
                key={`channel_${index}`}
                index={ index }
                channelTitle={c.title}
                channelLink={c.link}
                channelSize={c.channelSize}
                items={c.teasers} />,
            )
          }
        </Col >
      </div >
    );
  }
}

export default Overview;
